import React, { FC } from 'react'
import { Box, Paper, Theme, createStyles, makeStyles, IconButton } from '@material-ui/core'
import { ReactComponent as CloseIcon } from 'assets/close.svg'
import { About } from 'components'
import { Modal } from 'components/modal'

interface AboutEventModalProps {
  onClose: () => void
  open: boolean
}

export const AboutEventModal: FC<AboutEventModalProps> = ({ open, onClose }) => {
  const classes = useStyles()

  return (
    <Modal onClose={onClose} open={open} className={classes.modal}>
      <Box className={classes.container}>
        <Paper className={classes.paper} square>
          <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <About />
        </Paper>
      </Box>
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      alignItems: 'unset !important',
      margin: '5vh auto 0',
      maxHeight: '95vh',
      minWidth: '60%',
      maxWidth: '70%',
      [theme.breakpoints.down('xs')]: {
        '& > div': {
          width: '100vw'
        }
      }
    },
    closeButton: {
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(3)
    },
    paper: {
      padding: theme.spacing(8, 10),
      position: 'relative',
      width: '100%',

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(8, 4)
      }
    },
    container: {
      overflowY: 'auto',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    eventAgendaContainer: {
      marginTop: theme.spacing(6)
    },
    introContainer: {
      marginTop: 13
    },
    agendaItemTitle: {
      fontSize: 18,
      marginBottom: 7,
      lineHeight: '16.8px'
    },
    presenter: {
      fontSize: 16,
      lineHeight: '19.15px',
      marginBottom: 10
    },
    multiPresenter: {
      marginBottom: 4
    },
    eventDate: {
      fontSize: 16,
      marginTop: 16
    },
    itemDetails: {
      fontSize: 14,
      lineHeight: '16.76px'
    },
    sectionTitle: {
      fontSize: 28,
      '&:after': {
        backgroundColor: '#d52b1e',
        content: '" "',
        height: 4,
        marginTop: theme.spacing(1),
        width: 32,
        display: 'block'
      }
    },
    table: {
      '& .MuiTableCell-root': {
        borderBottom: 'none',
        paddingLeft: 0
      }
    },
    tableSchedule: {
      minWidth: 210,
      verticalAlign: 'top'
    },
    footer: {
      backgroundColor: '#F6F6F6'
    }
  })
)
